import { render, staticRenderFns } from "./ProjectPeriods.vue?vue&type=template&id=d6aa1bba"
import script from "./ProjectPeriods.vue?vue&type=script&lang=js"
export * from "./ProjectPeriods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports